import { logMessage } from "../../logger/logger";
import { LogTypes } from "../../logger/logger.typings";

export const logFeatureUsage = (eventName: string) =>
  logMessage({
    description: `feature usage of user preference persistance`,
    event: eventName,
    feature: `${eventName}.persist`,
    name: `${eventName}.persist`,
    type: LogTypes.feature,
  });
